import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import "./style.scss";
import { useTranslation } from "react-i18next";

const CardBalance: React.FC = () => {
  const userData = useSelector((state: State) => state.auth.userData);
  const { t } = useTranslation();
  return (
  <React.Fragment>
  {userData.captionDepositBalance !== "0.00" &&
    userData.captionDepositBalance !== null && (
      <h1 style={{ marginBottom: "8px", fontSize: "18px" }}>
        {userData.descriptionDepositBalance}<br />
        <strong>{userData.captionDepositBalance} {t("zl")}</strong>
      </h1>
    )}

  {userData.captionBalanceI !== "0.00" &&
    userData.captionBalanceI !== null && (
      <h1 style={{ marginBottom: "8px", fontSize: "18px" }}>
        {userData.descriptionBalanceI}<br />
        <strong>{userData.captionBalanceI} {t("zl")}</strong>
      </h1>
    )}

  {userData.captionBalanceII !== "0.00" &&
    userData.captionBalanceII !== null && (
      <h1 style={{ marginBottom: "8px", fontSize: "18px" }}>
        {userData.descriptionBalanceII}<br />
        <strong>{userData.captionBalanceII} {t("zl")}</strong>
      </h1>
    )}

  {userData.captionBalanceIII !== "0.00" &&
    userData.captionBalanceIII !== null && (
      <h1 style={{ marginBottom: "8px", fontSize: "18px" }}>
        {userData.descriptionBalanceIII}<br />
        <strong>{userData.captionBalanceIII} {t("zl")}</strong>
      </h1>
    )}

  {userData.captionBalanceI === "0.00" &&
    userData.captionBalanceII === "0.00" &&
    userData.captionBalanceIII === "0.00" && (
      <h1 style={{ marginTop: "12px", fontSize: "18px", opacity: 0.7 }}>
        {t("brak_srodkow")}
      </h1>
    )}
</React.Fragment>
  );
};

export default CardBalance;
